var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1948 32.9502H44.0508V47.0347H55.2903V52.9317H44.0508V67.0152H51.5448C53.4703 67.0152 67.3528 67.2327 67.3313 50.6292C67.3098 34.0257 53.8668 32.9502 51.1948 32.9502Z",
    fill: "#C2A633"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 0C22.3855 0 0 22.3855 0 50C0 77.6145 22.3855 100 50 100C77.6145 100 100 77.6145 100 50C100 22.3855 77.6145 0 50 0ZM51.9645 77.005H33.857V52.932H27.474V47.035H33.8565V22.9605H49.3975C53.074 22.9605 77.4255 22.197 77.4255 50.4345C77.4255 79.139 51.965 77.005 51.965 77.005H51.9645Z",
    fill: "#C2A633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoge);
export default __webpack_public_path__ + "static/media/DOGE.0792f405ea03a83eb6f54a62ae4a7307.svg";
export { ForwardRef as ReactComponent };